<template>
  <div>
    <Head title="Agencies" />
    <h1>Agencies</h1>

    <div class="d-flex justify-content-between mb-3">
      <search-filter v-model="form.search" @reset="reset" />

      <Link class="btn btn-primary" href="/agencies/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Agency</span>
      </Link>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>City</th>
            <th>Country</th>
            <th>Email</th>
            <th>Phone</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="agency in agencies.data" :key="agency.id">
            <td>
              <Link class="" :href="`/agencies/${agency.id}/view`">
                {{ agency.name }}
                <icon v-if="agency.deleted_at" name="trash" width="20" height="20" />
              </Link>
            </td>
            <td>
              <Link :href="`/agencies/${agency.id}/view`" tabindex="-1">
                {{ agency.city }}
              </Link>
            </td>
            <td>
              <Link :href="`/agencies/${agency.id}/view`" tabindex="-1">
                {{ agency.country }}
              </Link>
            </td>
            <td>
              <a :href="`mailto:${agency.email}`" tabindex="-1">
                {{ agency.email }}
              </a>
            </td>
            <td>
              <Link :href="`/agencies/${agency.id}/view`" tabindex="-1">
                {{ agency.phone }}
              </Link>
            </td>
          </tr>
          <!-- <tr v-if="agencies.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">No agencies found.</td>
          </tr> -->
        </tbody>
      </table>
    </div>
    <!-- <pagination class="mt-6" :links="agencies.links" /> -->
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    agencies: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/agencies', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
